import React from "react";

const HSpace: React.FC = () => {
  return <div className="mr-2" />;
};

export default HSpace;
